import React from 'react';

// Renders the PLANNED value with inline rollover badges: green +X for volume rolled in
// from another period, red -X for volume rolled out to later periods (CD-5191).
const PlannedCell = ({ item }) => {
  return (
    <span>
      {item.NumberOfPlannedAssignments}
      {item.RolledInVolume > 0 && (
        <span
          className='text-success ms-1'
          title={`+${item.RolledInVolume} rolled in from another period`}
        >
          +{item.RolledInVolume}
        </span>
      )}
      {item.RolledOutVolume > 0 && (
        <span
          className='text-danger ms-1'
          title={`-${item.RolledOutVolume} rolled over to later periods`}
        >
          -{item.RolledOutVolume}
        </span>
      )}
    </span>
  );
};

export default PlannedCell;
